import { Backdrop } from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { useWallet } from "@solana/wallet-adapter-react";
import React from "react";
import { connect } from "react-redux";
import { SAN_MINT, USDC_MINT } from "src/assets/constants";
import AMC from "src/components/AMC/AMC";
import { setSanBalance, setUsdcBalance } from "src/store/actions/tradeActions";
import { getTokenBalance } from "src/utils/solanaRpc";
import CustomAppBar from "../../components/AppBar/CustomAppBar";

const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://material-ui.com/">
        Solana AMC
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  card: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  cardMedia: {
    paddingTop: "56.25%", // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  headingText: {
    paddingTop: 16,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    marginTop: 64,
  },
}));

const LandingPage = (props) => {
  const classes = useStyles();
  const { publicKey } = useWallet();

  React.useEffect(() => {
    getTokenBalance({
      solAddress: publicKey,
      mintAddress: USDC_MINT,
    }).then((usdc) => props.setUsdcBalance(usdc));
    getTokenBalance({
      solAddress: publicKey,
      mintAddress: SAN_MINT,
    }).then((san) => props.setSanBalance(san));
  }, [publicKey]);

  return (
    <React.Fragment>
      <CssBaseline />
      <CustomAppBar />
      <main>
        {/* Hero unit */}
        <div className={classes.heroContent}>
          <Typography
            variant="h3"
            align="center"
            color="textSecondary"
            className={classes.headingText}
          >
            Smartest AMC on Fastest Blockchain
          </Typography>
          <AMC />
          <Backdrop className={classes.backdrop} open={true}>
            <img
              src="https://raw.githubusercontent.com/solana-amc/assets/main/images/coming-soon.svg"
              alt=""
              width="300"
            />
          </Backdrop>
        </div>
      </main>
      {/* Footer */}
      <footer className={classes.footer}>
        <Copyright />
      </footer>
      {/* End footer */}
    </React.Fragment>
  );
};

const mapStateToProps = ({ tradeInfo }) => ({
  tradeInfo: tradeInfo,
});

const mapDispatchToProps = {
  setUsdcBalance,
  setSanBalance,
};

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);
